import repositoryFactory from '@/helpers/api/apiFactory';
const api = repositoryFactory('favorites');

const state = { 
    favorites: null
};

const mutations = {
    setState: (state, {key, value}) => {
        state[key] = value;
    }
};

const actions = {   
    async get({commit, state}) { 
        try {
            const response = await api.get();  
        
            commit('setState', {
                key: 'favorites',
                value: response.data.data != undefined ? response.data.data : []
            }); 
        } catch (err) {} 
    },  

    async add({commit}, id) { 
        return await api.add(id); 
    },

    async remove({commit}, id) { 
        return await api.remove(id); 
    },

    async clear({dispatch}) {
        const response = await api.clear();  

        dispatch('get');
        return response;
    }
};

const getters = {  
    favorites: state => state.favorites
};

export default {
    namespaced: true,
    state, 
    mutations,
    actions,
    getters
};